<template>
  <div>
    <v-card :loading="loading">
      <v-card-title class="d-flex w-full align-center">
        <h5 class="">
          <span v-if="fullAccess">Todas Solicitações</span>
          <span v-else>Minhas Solicitações</span>
        </h5>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="addServiceRequest" small>
          <v-icon left>mdi-plus</v-icon>
          Nova Solicitação
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-data-table :items="quotationList" :headers="headers">
          <template v-slot:item.status="{ item }">
            <v-chip :color="statusColors[item.status] || 'grey'" small label>
              {{ statusTexts[item.status] || item.status }}
            </v-chip>
          </template>
          <template v-slot:item.deadline="{ item }">
            {{ item.deadline | date }}
          </template>
          <template v-slot:item.actions="{ item }">
            <TooltipedBtn
              v-if="fullAccess || item.requiredById === user.id"
              small
              :to="{ name: 'quotation.details', params: { id: item.id } }"
              icon
            >
              <v-icon small>mdi-eye</v-icon>
            </TooltipedBtn>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <BudgetRequestModal @success="refresh" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import BudgetRequestModal from '@/components/services/modal/BudgetRequestModal.vue'

export default {
  name: 'App',
  components: { BudgetRequestModal },
  data: () => ({
    headers: [
      { text: 'Servico', value: 'Service.name' },
      { text: 'Descrição', value: 'description' },
      { text: 'Prazo', value: 'deadline' },
      { text: 'Solicitado por', value: 'RequiredBy.name' },
      { text: 'Responsável', value: 'Responsible.name' },
      { text: 'Status', value: 'status' },
      { text: 'Ações', value: 'actions' },
    ],
    statusColors: {
      declined: 'orange',
      accepted: 'success',
      pending: 'blue',
      done: 'info',
    },
    statusTexts: {
      accepted: 'Aceito',
      pending: 'Pendente',
      declined: 'Em Andamento',
      done: 'Concluído',
    },
  }),
  methods: {
    addServiceRequest() {
      this.$root.$emit('service-request')
    },
    refresh() {
      this.$emit('refresh')
    },
  },
  computed: {
    ...mapGetters('auth', ['user', 'hasPermission']),
    fullAccess() {
      return this.hasPermission(1073741824)
    },
    quotationList() {
      return this.quotations.filter(({ requiredById }) => this.fullAccess || requiredById === this.user.id)
    },
  },
  props: {
    loading: Boolean,
    quotations: Array,
  },
}
</script>

<style>
/* Add your styles here */
</style>
